function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import ModalHeader from '../../modal/ModalHeader.react';
import Select from '../../common/form/Select.react';
var LocationPersonnelSort = function LocationPersonnelSort(_ref) {
  var locationID = _ref.locationID,
    contactID = _ref.contactID,
    personnel = _ref.personnel;
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 1),
    position = _useState2[0];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  useEffect(function () {
    setItems(personnel.filter(function (x) {
      return x._id !== contactID;
    }).sort(function (a, b) {
      return a.slot - b.slot;
    }));
  }, [personnel]);
  var firstItem = [{
    sLabel: '0',
    sValue: 0
  }];
  items.forEach(function (x, i) {
    firstItem.push({
      sLabel: i + 1,
      sValue: i + 1
    });
  });
  var handleOnChange = function handleOnChange(_ref2) {
    var sValue = _ref2.sValue;
    var arr = [];
    var count = 0;
    for (var i = 0; i < items.length + 1; i++) {
      if (i === sValue) {
        arr.push({
          contactID: contactID,
          slot: sValue
        });
      } else {
        arr.push({
          contactID: items[count]._id,
          slot: i
        });
        count++;
      }
    }
    dispatch({
      type: ppcActions.location,
      payload: {
        formData: {
          locationID: locationID,
          arr: arr
        },
        method: 'put',
        route: 'personnel-slot'
      }
    });
    dispatch({
      type: modalActions.hide
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Arrange Contact Persons"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Select, {
    value: position,
    options: firstItem,
    onChange: function onChange(position) {
      handleOnChange(position);
    },
    placeholder: "Select to change position"
  })));
};
export default LocationPersonnelSort;